(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  let lastFocus = null;

  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const f = d.querySelector('button, a, input');
    if (f) setTimeout(() => f.focus(), 50);
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  window.GZ = { openDrawer };

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.openDrawer); return; }
    const closer = e.target.closest('[data-close-drawer]');
    if (closer) { closeDrawer(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
  });

  // ---- Cart (Shopify Ajax API + Section Rendering) ----
  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.hidden = count === 0; });
  }
  async function refreshDrawer() {
    const res = await fetch(`${window.routes.cart_url}?section_id=cart-drawer-content`);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-drawer-inner]');
    const cur = $('[data-cart-drawer-inner]');
    if (fresh && cur) cur.replaceWith(fresh);
    const cart = await (await fetch(`${window.routes.cart_url}.js`)).json();
    updateCount(cart.item_count);
    return cart;
  }
  function toast(msg, isErr) {
    let t = $('#gz-toast');
    if (!t) { t = document.createElement('div'); t.id = 'gz-toast'; t.setAttribute('role', 'status'); t.style.cssText = 'position:fixed;top:16px;left:50%;transform:translateX(-50%);z-index:80;padding:12px 18px;border-radius:8px;font-weight:600;font-size:.92rem;box-shadow:0 10px 30px -10px rgba(0,0,0,.3);transition:opacity .3s'; document.body.appendChild(t); }
    t.textContent = msg; t.style.background = isErr ? '#9b1c1c' : '#0b1426'; t.style.color = '#fff'; t.style.opacity = '1';
    clearTimeout(t._h); t._h = setTimeout(() => (t.style.opacity = '0'), 3200);
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    const submitter = e.submitter;
    if (submitter && submitter.name === 'buy_now') return; // let native form go to checkout via return_to
    e.preventDefault();
    const btn = form.querySelector('[type=submit]');
    const label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = btn.dataset.loading || 'Adding…'; }
    try {
      const res = await fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
      document.dispatchEvent(new CustomEvent('gz:add_to_cart', { detail: data }));
      await refreshDrawer();
      openDrawer('CartDrawer');
    } catch (err) {
      toast(err.message, true);
    } finally {
      if (btn) { btn.disabled = false; btn.innerHTML = label; }
    }
  });

  async function changeLine(key, quantity) {
    const inner = $('[data-cart-drawer-inner]') || document.body;
    inner.classList.add('is-loading');
    try {
      const res = await fetch(window.routes.cart_change_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'Could not update cart');
      if (document.body.classList.contains('template-cart')) { location.reload(); return; }
      await refreshDrawer();
    } catch (err) { toast(err.message, true); }
    finally { const i = $('[data-cart-drawer-inner]'); if (i) i.classList.remove('is-loading'); }
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    changeLine(b.dataset.key, parseInt(b.dataset.qty, 10));
  });
  document.addEventListener('change', (e) => {
    const i = e.target.closest('[data-line-input]');
    if (i) changeLine(i.dataset.key, Math.max(0, parseInt(i.value, 10) || 0));
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
  });

  // ---- Product page: variants + gallery ----
  $$('[data-product]').forEach((root) => {
    const json = root.querySelector('[data-product-json]');
    if (!json) return;
    const product = JSON.parse(json.textContent);
    const idInput = root.querySelector('input[name=id]');
    const priceEl = root.querySelector('[data-price]');
    const stockEl = root.querySelector('[data-stock]');
    const atc = root.querySelectorAll('[data-atc]');
    const money = (c) => (c / 100).toLocaleString(undefined, { style: 'currency', currency: root.dataset.currency || 'USD' });
    function current() {
      const sel = product.options.map((_, i) => { const c = root.querySelector(`input[data-option-index="${i}"]:checked`); return c ? c.value : null; });
      return product.variants.find((v) => v.options.every((o, i) => o === sel[i]));
    }
    function render() {
      const v = current();
      atc.forEach((b) => { b.disabled = !v || !v.available; });
      if (!v) { if (stockEl) { stockEl.textContent = 'Unavailable'; stockEl.classList.add('out'); } return; }
      idInput.value = v.id;
      if (priceEl) {
        const sale = v.compare_at_price && v.compare_at_price > v.price;
        priceEl.className = 'price' + (sale ? ' price--sale' : '');
        priceEl.innerHTML = `<span class="price__now">${money(v.price)}</span>` + (sale ? `<s>${money(v.compare_at_price)}</s><span class="save-badge">Save ${money(v.compare_at_price - v.price)}</span>` : '');
      }
      if (stockEl) { stockEl.textContent = v.available ? (product.handle === 'gizmoozle-december-road-trip-kit' ? 'Subject to availability' : 'In stock — ready to order') : 'Sold out'; stockEl.classList.toggle('out', !v.available); }
      atc.forEach((b) => { if (b.dataset.atc === 'add') b.textContent = v.available ? 'Add to cart' : 'Sold out'; });
      if (v.featured_media) showMedia(String(v.featured_media.id));
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    }
    function showMedia(id) {
      const btn = root.querySelector(`[data-media-id="${id}"]`);
      if (btn) btn.click();
    }
    root.addEventListener('change', (e) => { if (e.target.matches('[data-option-index]')) render(); });
    root.addEventListener('click', (e) => {
      const t = e.target.closest('[data-media-id]');
      if (!t) return;
      const main = root.querySelector('[data-main-image]');
      main.src = t.dataset.src; main.srcset = ''; main.alt = t.dataset.alt || '';
      root.querySelectorAll('[data-media-id]').forEach((b) => b.setAttribute('aria-current', b === t ? 'true' : 'false'));
    });
    const sticky = $('.sticky-atc');
    const buy = root.querySelector('.buy');
    if (sticky && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(buy);
    }
  });

  // ---- Recommendations (Shopify native) ----
  $$('[data-recommendations]').forEach(async (el) => {
    try {
      const html = await (await fetch(el.dataset.url)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('[data-recommendations]');
      if (inner && inner.querySelector('.card')) el.innerHTML = inner.innerHTML; else el.remove();
    } catch (e) { el.remove(); }
  });

  // ---- Reveal on scroll ----
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((ents) => ents.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach((el) => io.observe(el));
  } else { $$('.reveal').forEach((el) => el.classList.add('in')); }
})();
